module.exports = __webpack_public_path__ + "img/BV.e68ff001.svg";